var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.096,
    height: 18.096,
    viewBox: "0 0 18.096 18.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fdfdfd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.696 1.319)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.776,15.08A3.779,3.779,0,0,1,0,11.307V7.148A3.779,3.779,0,0,1,3.776,3.374h.154a3.416,3.416,0,0,1,6.828-.124l0,.124h.166A3.779,3.779,0,0,1,14.7,7.148v4.159a3.779,3.779,0,0,1-3.776,3.774ZM1.131,7.148v4.159a2.646,2.646,0,0,0,2.644,2.642h7.151a2.647,2.647,0,0,0,2.645-2.642V7.148a2.647,2.647,0,0,0-2.645-2.642h-.165V5.7a.566.566,0,0,1-1.126.077L9.631,5.7V4.505H5.06V5.7a.566.566,0,0,1-1.126.077l0-.077V4.505H3.776A2.646,2.646,0,0,0,1.131,7.148Zm8.5-3.774a2.286,2.286,0,0,0-4.566-.11l0,.11Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.126e82f9ec55fd428cd5f2573c919d05.svg";
export { ForwardRef as ReactComponent };